import React from 'react';
import Info from '@material-ui/icons/Info';

import Snackbar from '../../../labels/Snackbar';

class BubbleChart extends React.Component {

    state = {
        message: undefined
    }

    handleOpenMessage = () => {
        const {intl} = this.props;
        const message = intl.formatMessage({ id: 'widget_title_time' }) + ": " + intl.formatMessage({ id: 'widget_'+ this.props.period });
        this.setState({message: message });
    };

    handleCloseMessage = () => {
        this.setState({message: undefined});
    };

    render() {
        const {message} = this.state;

        return  <span>
                    <Info className="c_bluish hand" onClick={this.handleOpenMessage.bind(this)} />
                    {message && (
                        <Snackbar
                            open={true}
                            variant="info"
                            text={message}
                            onClose={this.handleCloseMessage.bind(this)}
                        />
                    )}
                </span>
    }
}

export default BubbleChart;


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/types/PeriodLabel.js